import { PromoTag } from '@snack-uikit/promo-tag';
import { Typography } from '@snack-uikit/typography';

import styles from './styles.module.scss';

const DEFAULT_ICON = '/svg/components/ProductsCatalog/icon.svg';

export type BlogProduct = {
  name: string;
  icon?: string;
  onClick: () => void;
};

type ProductsProps = {
  products: BlogProduct[];
};

export function Products(props: ProductsProps) {
  const { products } = props;

  return (
    <div className={styles.products}>
      <Typography.SansBodyL className={styles.label} tag="span">
        Продукты из этой статьи:
      </Typography.SansBodyL>
      <div className={styles.tags} data-test-id="article-products">
        {products.map(({ name, icon, onClick }) => (
          <PromoTag
            key={name}
            appearance="neutral"
            color="decor"
            size="s"
            text={name}
            beforeContent={
              <div className={styles.iconWrapper}>
                <img
                  src={icon || DEFAULT_ICON}
                  alt={`Иконка-${name}`}
                  width={20}
                  height={20}
                />
              </div>
            }
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
}
